import { FetchContext } from '../fetch-context';
import { Group } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getGroups: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<Group[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/groups`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<Group[]>(fetchContext.errorStore, response, 'get groups'));
